import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  authKeysDialog: {
    '& .MuiPaper-root': {
      border: `1px solid ${theme.vars.palette.divider}`,
      boxShadow: 'none'
    },
    '& .MuiCardHeader-root': {
      backgroundColor: theme.vars.palette.background.elevation0,
      borderRadius: '4px 4px 0 0'
    }
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500]
  },
  authKeyItem: {
    backgroundColor: theme.vars.palette.background.elevation0_a25,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.vars.palette.divider}`
  },
  copyTextItem: {
    padding: theme.spacing(1, 1, 1, 2),
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));

export default useStyles;
